import { createReducer, on } from '@ngrx/store';

import { IDropDownList } from '@interfaces';
import { addWorkArea, loadWorkAreaSuccess, removeWorkArea, updateWorkArea } from './workArea.actions';

export interface WorkAreaState {
  workArea: IDropDownList[];
}

export const initialState: WorkAreaState = {
  workArea: [],
};

const _workAreaReducer = createReducer(
  initialState,
  on(loadWorkAreaSuccess, (state, { workArea }) => ({ ...state, workArea })),
  on(addWorkArea, (state, { workArea }) => ({
    ...state,
    workArea: [...state.workArea, workArea],
  })),
  on(removeWorkArea, (state, { workAreaId }) => ({
    ...state,
    workArea: state.workArea.filter((workArea) => workArea.id !== workAreaId),
  })),
  on(updateWorkArea, (state, { workArea }) => ({
    ...state,
    workArea: state.workArea.map((workAreaItem) => {
      if (workAreaItem.id === workArea.id) {
        return { ...workArea };
      } else {
        return workAreaItem;
      }
    }),
  })),
);

export function workAreaReducer(state: WorkAreaState | undefined, action: any) {
  return _workAreaReducer(state, action);
}
